<template>
  <div>
    <filters-bar
    title="Clientes"
    title-class="headline"
    :filters="filters"
    :has-channel="true"
    :has-date-type="true"
    :filters-button="true"
    @search="setFilters">
    </filters-bar>
    <v-layout row wrap pa-0 ma-0 justify-end>
      <p class="caption" v-if="date">
        Ultima actualización {{ date }}
      </p>
    </v-layout>
    <graphics
      graphic-id-one="totalsGraphic"
      graphic-id-two="sendsGraphic"
      :filters="filters"
      url="notification_customers"
    ></graphics>
  </div>
</template>

<script>
import moment from 'moment';
import reportsListMixin from '@/mixins/reportsList';
import graphics from '@/components/panel/customer_schedules/Graphics';
import FiltersBar from '@/components/global/FiltersBar';

export default {
  mixins: [
    reportsListMixin,
  ],
  components: {
    graphics,
    FiltersBar,
  },
  props: ['date'],
  data() {
    return {
      filterActive: false,
      filters: {
        date: moment().format('YYYY-MM-DD'),
        channel: 4,
        dateType: 'date',
        campaign: this.campaignFilter,
      },
    };
  },
  methods: {
    setFilters(filters) {
      this.filters = {
        ...this.filters,
        ...filters,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/panel/customer_schedules/Index.vue